import { render, staticRenderFns } from "./MileageItem.vue?vue&type=template&id=45d21215&scoped=true&"
import script from "./MileageItem.vue?vue&type=script&lang=js&"
export * from "./MileageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d21215",
  null
  
)

export default component.exports